import { useEffect, useState } from "react";
import { api } from "./api";

const FALLBACK = { amount: "11.00", currency: "USD", symbol: "$", display: "$11.00", period: "month" };
let cache = null;

export function usePricing() {
  const [pricing, setPricing] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    api
      .get("/payments/pricing")
      .then((r) => {
        cache = r.data;
        setPricing(r.data);
      })
      .catch(() => setPricing(FALLBACK));
  }, []);
  return pricing;
}
